import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-KXN5VN4WKZ', {
    gtagOptions: {
      // Custom parameters to identify this app/subdomain
      app_name: 'Ptau Clinical Trials',
      app_version: '1.0',
      send_page_view: true
    }
  });

  // Set custom dimension for all events
  ReactGA.set({
    app_source: 'ptau-clinical-trials',
    environment: process.env.NODE_ENV || 'production'
  });
};

export const logPageView = () => {
  ReactGA.send({ 
    hitType: 'pageview', 
    page: window.location.pathname,
    title: document.title
  });
};